export const publicRouter = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue')
    },
    {
            path: '/formatter',
            name: 'formatter',
            component: () => import('../views/formatter/Formatter.vue')
        },
    {
        path: '/learn',
        name: 'learn',
        component: () => import('../views/Learn.vue')
    },
    {
        path: '/inprogress',
        name: 'inprogress',
        component: () => import('../views/Inprogress.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/About.vue')
    },
    {
        path: '/donate',
        name: 'donate',
        component: () => import('../views/Donate.vue')
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('../views/Error.vue')
    }
];
